module.exports = __webpack_public_path__ + "img/banner-1.a8f55eb6.jpg";